import {
   words,
   collectibleWordTextKeys,
} from './globalState';
import {
  otherSide,
  getCardStatus
} from 'utils/utilsKom';
import { devLog } from 'dev/development';

// HANDLE CLICK LEAVE DUEL
function handleClickLeaveDuel(state, dispatch, navigate, popupLayer) {
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;

  const body =
  <div className='flexColumn alignItemsCenter' >
    <div className='margin1' >
      { words.areYouSureYouWantToLeaveTheDuel[state.language] }
    </div>
    <div className='flexRow alignItemsCenter' >
      <button className='button2 flexRow justifyContentCenter alignItemsCenter '
        onClick={ () => {
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: { type: null, body: null } }); 
          handleClickEndDuel(state, dispatch, navigate);

          // if (state.webSocketContainer.webSocket !== undefined || state.webSocketContainer.webSocket !== null) {
          //   try {
          //     const requestBody = {
          //       action: 'endDuel',
          //       addressMain: state.active.addressMain,
          //       sessionId: state.session[state.active.addressMain].sessionId,
          //     };

          //     state.webSocketContainer.webSocket?.send(JSON.stringify(requestBody));
          //     state.webSocketContainer.webSocket?.close(1000, 'leave', { keepClosed: true });
          //     devLog('WebSocket closed');
          //   }
          //   catch (error) {
          //     devLog('WebSocket may already be closed.', JSON.stringify(error));
          //     handleClickEndDuel(state, dispatch, navigate);
          //   }
          // }
          // else {
          //   handleClickEndDuel(state, dispatch, navigate);
          // }
        }}
      >
        <div>
          { 'OK' }
        </div>
      </button>
      <button className='button2 flexRow justifyContentCenter alignItemsCenter '
        onClick={ () => {
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: { type: null, body: null } }); 
        }}
      >
        <div>
          { words.cancel[state.language] }
        </div>
      </button>
    </div>
  </div>;

  const popup = {
    type: 'generalItems',
    body: body,
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
}

// HANDLE CLICK END DUEL
function handleClickEndDuel(state, dispatch, navigate) {
  // // クライアントのduelステータスを初期化

  // const duel = {
  //   visible: false,
  //   textCount: 0,
  //   text: '',
  //   chunks: [],
  //   straightManChunks: [],
  //   round: 0,
  //   status: undefined,
  //   myStatus: null,
  //   action: undefined,
  //   pointA: 0,
  //   pointB: 0,
  //   winner: undefined,
  //   winningMonster: undefined,
  //   winningMonsterIndex: undefined,
  //   monstersInformation: undefined,
  //   monstersInformationRevised: undefined,
  //   monstersIndex: undefined,
  //   result: [],
  //   maginaPoint: {
  //     A: 0,
  //     B: 0,
  //   },
  //   basicInformation: undefined,
  //   castMagics: [],
  //   magics: {
  //     A: [],
  //     B: [],
  //   },
  //   initiative: undefined,
  //   imageNo: {
  //     A: 0,
  //     B: 0,
  //   },
  //   knightBoxEffect: {
  //     A: undefined,
  //     B: undefined,
  //   },
  //   selectStatus: {
  //     mode: 'neutral',
  //     routeIndex: null,
  //   },
  //   cardStatusTmp: {
  //     A: [],
  //     B: [],
  //   },
  // };

  // dispatch({type: 'setState', key: 'duel', value: duel});

  // // デュエル終了させてコネクションを切る
  // // ここで切れてない可能性は極めて低い。

  // try {
  //   const requestBody = {
  //     action: 'endDuel',
  //     addressMain: state.active.addressMain,
  //     sessionId: state.session[state.active.addressMain].sessionId,
  //   };

  //   state.webSocketContainer.webSocket?.send(JSON.stringify(requestBody));
  //   state.webSocketContainer.webSocket?.close(1000, 'leave', { keepClosed: true });
  //   devLog('WebSocket closed');
  // }
  // catch (error) {
  //   devLog('WebSocket may already be closed.', JSON.stringify(error));
  // }

  // dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'webSocket'], value: undefined});

  // // dispatch({type: 'setStateMultiLayers', keys: ['websocket', 'status'], value: 'close'});

  try {
    const requestBody = {
      action: 'endDuel',
      addressMain: state.active.addressMain,
      sessionId: state.session[state.active.addressMain].sessionId,
    };

    state.webSocketContainer.webSocket?.send(JSON.stringify(requestBody));
    // state.webSocketContainer.webSocket?.close(1000, 'leave', { keepClosed: true });
    // devLog('WebSocket closed');
  }
  catch (error) {
    devLog('WebSocket may already be closed.', JSON.stringify(error));
  }

  // イベントハンドラ削除は、アンマウント処理、unload処理に任せる。よって、ここでwebSocketをstateから削除してはいけない。
  // webSocketとduelのstate削除も、アンマウント処理、unload処理に任せる。

  const urlParams = (new URL(document.location)).searchParams;
  const roomId = urlParams.get('roomid') === null ? null : urlParams.get('roomid');
  const duelNo = urlParams.get('duelno') === null ? null : parseInt(urlParams.get('duelno'), 10);

  if (roomId === null || duelNo === null) { // roomId, duelNoが設定されてる場合、履歴詳細へnavigate中だからオーバーライドしないようにする。
    navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/top' : '/top');
  }
}

// CLEAN UP DUEL IN STATE
function cleanUpDuelInState(state, dispatch) {
  // クライアントのduelステータスを初期化

  const duel = {
    visible: false,
    textCount: 0,
    text: '',
    chunks: [],
    straightManChunks: [],
    round: 0,
    status: undefined,
    myStatus: null,
    action: undefined,
    actionOpponent: undefined,
    pointA: 0,
    pointB: 0,
    winner: undefined,
    winningMonster: undefined,
    winningMonsterIndex: undefined,
    monstersInformation: undefined,
    monstersInformationRevised: undefined,
    monstersIndex: undefined,
    result: [],
    collectibleWordSoundEffectNamesInDuel: [],
    collectibleWordSoundEffectNamesInBattle: [],
    maginaPoint: {
      A: 0,
      B: 0,
    },
    basicInformation: undefined,
    castMagics: [],
    magics: {
      A: [],
      B: [],
    },
    initiative: undefined,
    imageNo: {
      A: 0,
      B: 0,
    },
    knightBoxEffect: {
      A: undefined,
      B: undefined,
    },
    selectStatus: {
      mode: 'neutral',
      routeIndex: null,
    },
    cardStatusTmp: {
      A: [],
      B: [],
    },
  };

  dispatch({type: 'setState', key: 'duel', value: duel});
}

// SEND CHALLENGE DUEL
function sendChallengeDuel({
  webSocket,
  addressMain,
  sessionId,
  gameMode,
  difficultyMode,
  designatedAddressesCsv,
  gameOption,
  recoveryOnly,
}) {
  let designatedAddresses;
  const csv = designatedAddressesCsv.trim();

  if (csv !== '') {
    designatedAddresses = csv.split(/[\r\n,]+/).map( address => { return { address: address }; } );
  }

  const requestBody = {
    action: 'challengeDuel',
    addressMain: addressMain,
    sessionId: sessionId,
    connectionMatchingId: 'main',
    gameMode: gameMode,
    difficultyMode: difficultyMode,
    designatedAddresses: designatedAddresses,
    gameOption: gameOption,
    recoveryOnly: recoveryOnly,
  };

  webSocket.send(JSON.stringify(requestBody));
}

// HANDLE CLICK SUMMON MONSTER
function handleClickSummonMonster(state, dispatch, message) {
  const side = state.duel.basicInformation.side;

  const monstersInformation = {
    [side]: state.registeredCard[message.summonedMonster],
    [otherSide(side)]: state.registeredCard[state.duel.winningMonster],
  };

  const monstersIndex = {
    [side]: message.summonedMonsterIndex,
    [otherSide(side)]: state.duel.winningMonsterIndex,
  };

  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: []});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: []});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: ''});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: monstersInformation});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersIndex'], value: monstersIndex});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'comfirmed'});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'onBattle'});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'action'], value: message.action});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winner'], value: undefined});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: { [side]: state.duel.castMagics, [otherSide(side)]: [], }});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'imageNo'], value: { A: 0, B: 0, }});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'knightBoxEffect'], value: { A: undefined, B: undefined, }});
  dispatch({type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'visible'});
  state.webSocketContainer.webSocket?.send(JSON.stringify(message));
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'visible'], value: true});
}

// HANDLE CLICK COST MONSTER
function handleClickCostMonster(state, dispatch, asset, index) {
  const side = state.duel.basicInformation.side;
  const selectStatus = state.duel.selectStatus;
  const magic = state.duel.castMagics[selectStatus.magicIndex];
  const route = magic.route[selectStatus.routeIndex];
  const cost = magic.costs[route.index];
  const cards = cost.cards;
  const cardStatus = getCardStatus(state, side, index);
  const registeredCardInfo = state.registeredCard[asset];
  let statusTobe;

  // 選択条件チェック & 更新ステータスセット

  if (route.detail.type === 'discardCards') {
    if (cardStatus !== 'hand') {
      return;
    }

    statusTobe = 'cost';
  }
  else if (route.detail.type === 'excludeCardsFromCemetery') {
    if (cardStatus !== 'cemetery') {
      return;
    }

    statusTobe = 'costToBeExcludedFromCemetery';
  }
  else if (route.detail.type === 'excludeMonstersFromCemetery') {
    if (cardStatus !== 'cemetery') {
      return;
    }

    if (registeredCardInfo.category === 'magic') {
      return;
    }

    statusTobe = 'costToBeExcludedFromCemetery';
  }

  // コストセット

  cards.push({ asset: asset, index: index });

  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics', selectStatus.magicIndex, 'costs', route.index, 'cards'], value: cards});

  if (state.duel.cardStatusTmp[side][index] !== undefined) {
    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp', side, index, 'status'], value: statusTobe});
  }
  else {
    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp', side, index], value: { status: statusTobe }});
  }

  // ルーティング

  if (route.detail.comparison === 'equal') {
    if (cards.length === route.detail.amount) {
      if (selectStatus.routeIndex === magic.route.length - 1) {
        // 魔法モードを抜けニュートラル
        dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus'], value: { mode: 'neutral' }});
      }
      else {
        // 魔法モード継続。ルート1つ進む。
        dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus', 'routeIndex'], value: selectStatus.routeIndex + 1});
      }
    }
  }

  // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'visible'], value: true});
}

// HANDLE CLICK SELECT CEMETERY CARD
function handleClickSelectCemeteryCard(state, dispatch, sideCard, asset, index) {
  const sideDuelist = state.duel.basicInformation.side;
  const selectStatus = state.duel.selectStatus;
  const magic = state.duel.castMagics[selectStatus.magicIndex];
  const route = magic.route[selectStatus.routeIndex];
  const target = magic.targets[route.index][route.key];
  const cards = target.cards;

  if (route.detail.type === 'specify') {
    if (route.detail.source === 'cemeteryMyself') {
      cards.push({ side: sideCard, asset: asset, index: index });

      dispatch({
        type: 'setStateMultiLayers',
        keys: ['duel', 'castMagics', selectStatus.magicIndex, 'targets', route.index, route.key, 'cards'],
        value: cards
      });

      let data;
      // let targets;

      if (state.duel.cardStatusTmp[sideCard][index]?.targets !== undefined) {
        data = state.duel.cardStatusTmp[sideCard][index];
        data.targets.push({ side: sideDuelist, preEffectIndex: route.index, targetKey: route.key });
      }
      else if (state.duel.cardStatusTmp[sideCard][index] !== undefined) {
        data = state.duel.cardStatusTmp[sideCard][index];
        data.targets = [{ side: sideDuelist, preEffectIndex: route.index, targetKey: route.key }];
      }
      else {
        data = { targets: [{ side: sideDuelist, preEffectIndex: route.index, targetKey: route.key }] };
      }

      dispatch({
        type: 'setStateMultiLayers',
        keys: ['duel', 'cardStatusTmp', sideCard, index],
        value: data
      });
    }
  }
  else {
    return;
  }

  // ルーティング

  if (route.detail.comparison === 'equal') {
    if (cards.length === route.detail.amount) {
      if (selectStatus.routeIndex === magic.route.length - 1) {
        // 魔法モードを抜けニュートラル
        dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus'], value: { mode: 'neutral' }});
      }
      else {
        // 魔法モード継続。ルート1つ進む。
        dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus', 'routeIndex'], value: selectStatus.routeIndex + 1});
      }
    }
  }

  // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'visible'], value: true});
}

// HANDLE CLICK CAST MAGIC
function handleClickCastMagic(state, dispatch, asset, index) {
  const side = state.duel.basicInformation.side;

  // 真剣奈ポイントチェック
  // 仕様未定のため、magicOrderは0のみという前提。

  if ( state.registeredCard[asset].postEffects.filter( effect => effect.type === 'maginaPoint' && effect.amount * -1 > state.duel.maginaPoint[side] ).length > 0 ) {
    return { status: 'rejected' };   
  }

  // 一旦いまセットされてる魔法をキャンセル

  if (state.duel.castMagics[0]) {
    handleClickCancelMagic(state, dispatch, 0)
  }

  // ルーティングとハコ作り

  const route = [];
  const costs = [];
  const targets = [];

  // -- コスト
  if (state.registeredCard[asset].costs !== undefined) {
    for (const [index, cost] of state.registeredCard[asset].costs.entries()) {
      route.push({ type: 'cost', index: index, detail: cost });
      costs[index] = { cards: [] };
    }
  }
  
  // -- 対象
  if (state.registeredCard[asset].preEffects !== undefined) {
    for (const [index, effect] of state.registeredCard[asset].preEffects.entries()) {
      if (effect.targets !== undefined) {
        targets[index] = {};

        for (const key of Object.keys(effect.targets)) {
          if (effect.targets[key].type === 'specify') {
            route.push({ type: 'target', index: index, key: key, detail: effect.targets[key] });

            if (effect.targets[key].source === 'field') {
              targets[index][key] = { side: null };
            }
            else if (effect.targets[key].source === 'cemeteryMyself') {
              targets[index][key] = { cards: [] };
            }
          }
        }
      }
    }
  }

  devLog('route', JSON.stringify(route));

  // castMagics, magics設定

  const magic = {
    asset: asset,
    index: index,
    costs: costs,
    targets: targets,
    route: route,
  };

  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics', 0], value: magic}); // とりあえず0固定で。
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics', side, 0], value: magic}); // とりあえず0固定で。

  // 仮墓地送り

  if (state.duel.cardStatusTmp[side][index] !== undefined) {
    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp', side, index, 'status'], value: 'cast'});
  }
  else {
    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp', side, index], value: { status: 'cast' }});
  }

  // selectStatus変更

  if (route.length >= 1) {
    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus'], value: { mode: 'magic', magicIndex: 0, routeIndex: 0 }});
  }

  // if (state.registeredCard[asset].costs?.[0] !== undefined) {
  //   // コスト選択がある場合はコスト選択モード
  //   dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus'], value: { type: 'cost', detail: state.registeredCard[asset].costs[0] }}); // とりあえず0固定で。
  // }
  // else {
  //   // コスト選択が無い場合は対象選択モード（対象選択があれば）
  //   for (const [index, effect] of state.registeredCard[asset].preEffects.entries()) {
  //     if (effect.target === 'specify') {
  //       dispatch({
  //         type: 'setStateMultiLayers',
  //         keys: ['duel', 'selectStatus'],
  //         value: { type: 'cost', index: index, detail: state.registeredCard[asset].costs[0] }
  //       }); // とりあえず0固定で。

  //       break;
  //     }
  //   }
  // }

  // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'visible'], value: true});
}

// HANDLE CLICK CANCEL MAGIC
function handleClickCancelMagic(state, dispatch, index) {
  const side = state.duel.basicInformation.side;
  const magic = state.duel.castMagics[index];

  // 仮墓地から復活

  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp', side, magic.index, 'status'], value: 'available'}); // handに戻るとは限らない。

  for (const cost of magic.costs) {
    for (const card of cost.cards) {
      dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp', side, card.index, 'status'], value: 'available'}); // handに戻るとは限らない。
    }
  }

  // 対象をクリア

  for (const target of magic.targets) {
    for (const key of Object.keys(target)) {
      if (target[key].cards !== undefined) {
        for (const card of target[key].cards) {
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp', side, card.index, 'targets'], value: []});
        }
      }
    }
  }

  // castMagics, magicsクリア

  const magics = state.duel.castMagics.filter( (magic, i) => i !== index ); // 全魔法クリアが正解かもしれない。

  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics'], value: magics});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics', side], value: magics});

  // selectStatus変更

  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus'], value: { mode: 'neutral' }});
}

// HANDLE CLICK NEXT
function handleClickNext(state, dispatch, message) {
  const side = state.duel.basicInformation.side;

  const monstersInformation = {
    [side]: state.registeredCard[state.duel.winningMonster],
  };

  const monstersIndex = {
    [side]: state.duel.winningMonsterIndex,
  };

  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: []});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: []});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: ''});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: monstersInformation});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersIndex'], value: monstersIndex});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'comfirmed'});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'onBattle'});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'action'], value: message.action});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winner'], value: undefined});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: { [side]: state.duel.castMagics, [otherSide(side)]: [], }});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'imageNo'], value: { A: 0, B: 0, }});
  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'knightBoxEffect'], value: { A: undefined, B: undefined, }});
  dispatch({type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'visible'});
  state.webSocketContainer.webSocket?.send(JSON.stringify(message));
}

function createCollectibleWordUpdate({ word, face, image }) {
  return {
    word,
    face,
    image,
    count: {
      liveText: 0,
      field: 0,
      straightManText: 0,
      battle: 0,
      duel: 0,
    },
    soundEffects: [],
  };
}

function addCollectibleWordSoundEffect({ collectibleWordUpdate, soundEffect }) {
  if (!collectibleWordUpdate.soundEffects.some(({ effectName }) => effectName === soundEffect.effectName)) {
    collectibleWordUpdate.soundEffects.push({
      effectName: soundEffect.effectName,
      filename: soundEffect.filename,
    });
  }
}

function buildStoredCollectibleWordSoundEffectNames({ collectibleWords }) {
  return new Set(
    collectibleWords
    .flatMap(({ soundEffects }) => soundEffects)
  );
}

function buildCollectibleWordSoundEffectsInBattle({ result }) {
  const soundEffects = collectibleWordTextKeys
  .flatMap(textKey => result.soundEffects.collectibleWords[textKey])
  .map(({ soundEffect }) => soundEffect)
  .filter(soundEffect => soundEffect !== null);
  const soundEffectNamesInBattle = new Set();

  return soundEffects
  .filter(({ effectName }) => {
    if (soundEffectNamesInBattle.has(effectName)) {
      return false;
    }

    soundEffectNamesInBattle.add(effectName);
    return true;
  })
  .map(({ effectName, filename }) => ({
    effectName,
    filename,
  }));
}

function buildCollectibleWordSoundEffectNamesInBattle({
  result,
  collectibleWords,
  collectibleWordSoundEffectNamesInDuel,
}) {
  const storedSoundEffectNames = buildStoredCollectibleWordSoundEffectNames({ collectibleWords });
  const soundEffectNamesInDuel = new Set(collectibleWordSoundEffectNamesInDuel);

  return buildCollectibleWordSoundEffectsInBattle({ result })
  .map(({ effectName, filename }) => {
    let firstAppearance;

    if (!storedSoundEffectNames.has(effectName)) {
      firstAppearance = 'lifetime';
    }
    else if (!soundEffectNamesInDuel.has(effectName)) {
      firstAppearance = 'duel';
    }
    else {
      firstAppearance = 'known';
    }

    return {
      effectName,
      filename,
      firstAppearance,
    };
  });
}

function buildCollectibleWordSoundEffectNamesInDuel({
  collectibleWordSoundEffectNamesInDuel,
  collectibleWordSoundEffectNamesInBattle,
}) {
  return [
    ...collectibleWordSoundEffectNamesInDuel,
    ...collectibleWordSoundEffectNamesInBattle
    .map(({ effectName }) => effectName)
    .filter(effectName => !collectibleWordSoundEffectNamesInDuel.includes(effectName)),
  ];
}

function buildPreviousCollectibleWordsInDuel({ results }) {
  const wordsInDuel = new Set();

  for (const result of results) {
    if (result?.collectibleWords === undefined) {
      continue;
    }

    for (const textKey of collectibleWordTextKeys) {
      for (const { word } of result.collectibleWords[textKey]) {
        wordsInDuel.add(word);
      }
    }
  }

  return wordsInDuel;
}

function buildCollectibleWordUpdatesFromBattleUp({ result, previousResults }) {
  const collectibleWordUpdates = {};
  const wordsInBattle = new Set();
  const previousWordsInDuel = buildPreviousCollectibleWordsInDuel({ results: previousResults });

  for (const textKey of collectibleWordTextKeys) {
    for (const { word, count, face, image } of result.collectibleWords[textKey]) {
      if (collectibleWordUpdates[word] === undefined) {
        collectibleWordUpdates[word] = createCollectibleWordUpdate({ word, face, image });
      }

      collectibleWordUpdates[word].count[textKey] += count;
      wordsInBattle.add(word);
    }
  }

  for (const word of wordsInBattle) {
    collectibleWordUpdates[word].count.battle = 1;

    if (!previousWordsInDuel.has(word)) {
      collectibleWordUpdates[word].count.duel = 1;
    }
  }

  for (const textKey of collectibleWordTextKeys) {
    for (const { word, soundEffect } of result.soundEffects.collectibleWords[textKey]) {
      if (soundEffect === null) {
        continue;
      }

      if (collectibleWordUpdates[word] === undefined) {
        throw new Error(`collectible word sound effect has no matched word: ${word}`);
      }

      addCollectibleWordSoundEffect({
        collectibleWordUpdate: collectibleWordUpdates[word],
        soundEffect,
      });
    }
  }

  return collectibleWordUpdates;
}

function buildCollectibleWordFirstSeen({ roomId, duelNo, round, timestamp }) {
  const firstSeen = {
    round,
    timestamp,
  };

  if (roomId !== undefined) {
    firstSeen.roomId = roomId;
  }

  if (duelNo !== undefined) {
    firstSeen.duelNo = duelNo;
  }

  return firstSeen;
}

function mergeCollectibleWordSoundEffects({ storedSoundEffects, soundEffectsToAdd }) {
  return [
    ...storedSoundEffects,
    ...soundEffectsToAdd
    .map(({ effectName }) => effectName)
    .filter(effectName => !storedSoundEffects.includes(effectName)),
  ];
}

function buildUpdatedCollectionCollectibleWords({ collectibleWords, collectibleWordUpdates, language, firstSeen }) {
  return [
    ...collectibleWords.map(collectibleWord => {
      const collectibleWordUpdate = collectibleWordUpdates[collectibleWord.word];

      if (collectibleWord.language !== language || collectibleWordUpdate === undefined) {
        return collectibleWord;
      }

      return {
        ...collectibleWord,
        count: {
          liveText: collectibleWord.count.liveText + collectibleWordUpdate.count.liveText,
          field: collectibleWord.count.field + collectibleWordUpdate.count.field,
          straightManText: collectibleWord.count.straightManText + collectibleWordUpdate.count.straightManText,
          battle: collectibleWord.count.battle + collectibleWordUpdate.count.battle,
          duel: collectibleWord.count.duel + collectibleWordUpdate.count.duel,
        },
        soundEffects: mergeCollectibleWordSoundEffects({
          storedSoundEffects: collectibleWord.soundEffects,
          soundEffectsToAdd: collectibleWordUpdate.soundEffects,
        }),
      };
    }),
    ...Object.values(collectibleWordUpdates)
    .filter(({ word }) => !collectibleWords.some(({ word: storedWord, language: storedLanguage }) => {
      return storedLanguage === language && storedWord === word;
    }))
    .map(({ word, count, soundEffects }) => ({
      word,
      language,
      firstSeen,
      count,
      soundEffects: soundEffects.map(({ effectName }) => effectName),
    })),
  ];
}

function buildUpdatedCollectibleWordsMaster({ collectibleWordsMaster, collectibleWordUpdates, language }) {
  return Object.fromEntries([
    ...Object.entries(collectibleWordsMaster),
    ...Object.values(collectibleWordUpdates).map(({ word, face, image, soundEffects }) => {
      const wordMaster = collectibleWordsMaster[word];
      const storedVariations = wordMaster?.soundEffect?.variations ?? [];
      const variations = [
        ...storedVariations,
        ...soundEffects.filter(({ effectName }) => {
          return !storedVariations.some(({ effectName: storedEffectName }) => storedEffectName === effectName);
        }),
      ];

      return [
        word,
        {
          faces: {
            ...(wordMaster?.faces ?? {}),
            [language]: [
              wordMaster?.faces?.[language]?.[0] ?? face,
            ],
          },
          soundEffect: {
            variations,
          },
          image,
        },
      ];
    }),
  ]);
}

function buildUserWithCollectibleWordsFromBattleUp({ userRecord, result, previousResults, roomId, duelNo, round, language }) {
  const collectibleWordUpdates = buildCollectibleWordUpdatesFromBattleUp({
    result,
    previousResults,
  });
  const timestamp = Math.max(...Object.values(result.monstersSummonTime));
  const firstSeen = buildCollectibleWordFirstSeen({
    roomId,
    duelNo,
    round,
    timestamp,
  });

  return {
    ...userRecord,
    collection: {
      ...userRecord.collection,
      collectibleWords: buildUpdatedCollectionCollectibleWords({
        collectibleWords: userRecord.collection?.collectibleWords ?? [],
        collectibleWordUpdates,
        language,
        firstSeen,
      }),
    },
    collectibleWordsMaster: buildUpdatedCollectibleWordsMaster({
      collectibleWordsMaster: userRecord.collectibleWordsMaster,
      collectibleWordUpdates,
      language,
    }),
  };
}

function buildCollectibleWordAudioUrls({
  collectibleWordSoundHostPath,
  collectibleWordSoundSetting,
  collectibleWordSoundEffectNamesInBattle,
}) {
  const soundEffectsToPlay = {
    always: collectibleWordSoundEffectNamesInBattle,
    firstInDuel: collectibleWordSoundEffectNamesInBattle
    .filter(({ firstAppearance }) => firstAppearance === 'lifetime' || firstAppearance === 'duel'),
    firstInLifetime: collectibleWordSoundEffectNamesInBattle
    .filter(({ firstAppearance }) => firstAppearance === 'lifetime'),
  }[collectibleWordSoundSetting];
  const filenames = soundEffectsToPlay
    .map(({ filename }) => filename)
    .filter(filename => filename !== undefined);

  return filenames.map(filename => {
    return `https://${collectibleWordSoundHostPath}/${encodeURIComponent(filename)}`;
  });
}

export {
  handleClickLeaveDuel,
  handleClickEndDuel,
  cleanUpDuelInState,
  sendChallengeDuel,
  handleClickSummonMonster,
  handleClickCostMonster,
  handleClickSelectCemeteryCard,
  handleClickCastMagic,
  handleClickCancelMagic,
  handleClickNext,
  buildCollectibleWordAudioUrls,
  buildUserWithCollectibleWordsFromBattleUp,
  buildCollectibleWordSoundEffectNamesInBattle,
  buildCollectibleWordSoundEffectNamesInDuel,
};
